import React from 'react';
import { Box, TextField, Grid, FormControlLabel, Checkbox, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { FormPaymentData } from './FormPayment';
import MaskedTextField from '../../components/Inputs/MaskedTextField';

interface CreditCardFormProps {
    isSubscription?: boolean;
    formik: FormikProps<FormPaymentData>
}

const CreditCardForm: React.FC<CreditCardFormProps> = ({ isSubscription, formik }) => {
    return (
        <Box sx={{ mt: 2, mb: 3 }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <MaskedTextField
                        fullWidth
                        mask='0000 0000 0000 0000'
                        label="Número do Cartão"
                        name='number'
                        id='number'
                        variant="outlined"
                        placeholder="1234 5678 9012 3456"
                        inputProps={{ maxLength: 19 }}
                        value={formik.values.number}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.number && Boolean(formik.errors.number)}
                        helperText={formik.touched.number && formik.errors.number}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Nome no Cartão"
                        name="holderName"
                        id="holderName"
                        variant="outlined"
                        placeholder="Como aparece no cartão"
                        value={formik.values.holderName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.holderName && Boolean(formik.errors.holderName)}
                        helperText={formik.touched.holderName && formik.errors.holderName}
                        style={{ textTransform: 'uppercase' }}
                    />
                </Grid>
                <Grid item xs={6} sm={4}>
                    <MaskedTextField
                        fullWidth
                        label="Mes de Validade"
                        name='expiryMonth'
                        id='expiryMonth'
                        variant="outlined"
                        placeholder="MM"
                        mask='00'
                        value={formik.values.expiryMonth}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.expiryMonth && Boolean(formik.errors.expiryMonth)}
                        helperText={formik.touched.expiryMonth && formik.errors.expiryMonth}
                    />
                </Grid>
                <Grid item xs={6} sm={4}>
                    <MaskedTextField
                        fullWidth
                        label="Ano de Validade"
                        name='expiryYear'
                        id='expiryYear'
                        variant="outlined"
                        placeholder="AA"
                        mask="00"
                        value={formik.values.expiryYear}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.expiryYear && Boolean(formik.errors.expiryYear)}
                        helperText={formik.touched.expiryYear && formik.errors.expiryYear}
                    />
                </Grid>
                <Grid item xs={6} sm={4}>
                    <MaskedTextField
                        fullWidth
                        mask='000'
                        label="CVC"
                        name='ccv'
                        id='ccv'
                        variant="outlined"
                        placeholder="123"
                        value={formik.values.ccv}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.ccv && Boolean(formik.errors.ccv)}
                        helperText={formik.touched.ccv && formik.errors.ccv}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name='isSubscription'
                                id='isSubscription'
                                checked={formik.values.isSubscription}
                                onChange={formik.handleChange}
                            />
                        }
                        label="ATIVAR COBRANÇA RECORRENTE"
                    />
                </Grid>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                    * Ao ativar a cobrança recorrente, você concorda em pagar o valor da assinatura ao fim de cada ciclo do plano selecionado. 
                    O valor da cobrança será debitado do seu cartão automaticamente ao fim de cada ciclo
                </Typography>
            </Grid>
        </Box>
    );
};

export default CreditCardForm;